import { render, staticRenderFns } from "./discountOn.vue?vue&type=template&id=80feef04&"
import script from "./discountOn.vue?vue&type=script&lang=js&"
export * from "./discountOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports